import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "@/lib/auth";
import { toast } from "sonner";
import PhoneInput from "@/components/PhoneInput";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Account created. Welcome.");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] grid grid-cols-1 md:grid-cols-2" data-testid="register-page">
      <div className="flex items-center justify-center p-8 md:p-16">
        <form onSubmit={submit} className="w-full max-w-md space-y-5">
          <h2 className="font-display text-3xl font-black tracking-tight">Create your account</h2>
          <Field label="Full name" value={form.name} onChange={(v)=>setForm({...form, name:v})} testid="register-name" />
          <Field label="Email" type="email" value={form.email} onChange={(v)=>setForm({...form, email:v})} testid="register-email" />
          <div>
            <label className="label-eyebrow block mb-2">Phone</label>
            <PhoneInput value={form.phone} onChange={(v) => setForm({ ...form, phone: v })} required={false} testid="register-phone" />
          </div>
          <Field label="Password" type="password" value={form.password} onChange={(v)=>setForm({...form, password:v})} testid="register-password" />
          <button data-testid="register-submit" disabled={loading} className="btn-primary w-full" type="submit">
            {loading ? "Creating…" : "Create account"}
          </button>
          <p className="text-sm text-black/60">
            Already have an account? <Link to="/login" className="underline" data-testid="register-to-login">Sign in</Link>
          </p>
        </form>
      </div>
      <div className="hidden md:flex bg-black text-white p-12 flex-col justify-between">
        <p className="font-mono text-xs tracking-widest text-white/60">TWINSTARS / PLAZA / JOIN</p>
        <div>
          <h1 className="font-display text-5xl lg:text-7xl font-black tracking-tighter leading-[0.9]">
            Membership<br/>opens every door.
          </h1>
          <p className="text-white/60 mt-6 max-w-sm">Track bookings, earn wallet credits, redeem across the plaza.</p>
        </div>
        <p className="font-mono text-xs text-white/40">v1.0</p>
      </div>
    </div>
  );
}

function Field({ label, value, onChange, type="text", testid, required=true }) {
  return (
    <div>
      <label className="label-eyebrow block mb-2">{label}</label>
      <input data-testid={testid} required={required} type={type} className="input-sharp" value={value} onChange={(e)=>onChange(e.target.value)} />
    </div>
  );
}
